// ./RightSection.tsx
import { Drawer, Box, IconButton, Tooltip, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import HorizontalRuleRoundedIcon from '@mui/icons-material/HorizontalRuleRounded';
import { useTheme } from '@mui/material/styles';
import { SxProps, Theme } from '@mui/system';
import React, { useState } from 'react';
import KnowledgeBase from './KnowledgeBase';
import PdfViewer from './PdfViewer';

interface RightSectionProps {
  sx?: SxProps<Theme>;
  isOpen: boolean;
  onToggleSection: () => void;
}

const RightSection: React.FC<RightSectionProps> = ({ sx, isOpen, onToggleSection }) => {
  const [isHovered, setIsHovered] = useState(false);
  const theme = useTheme();

  return (
    <>
      <Tooltip title="Toggle right section">
        <IconButton
          onClick={onToggleSection}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          aria-label={isOpen ? 'Close section' : 'Open section'}
          sx={{
            position: 'fixed',
            right: isOpen ? '14.5%' : '-10px',
            top: '70%',
            transform: 'translateY(-50%)',
            backgroundColor: 'transparent',
            color: 'rgb(138, 43, 226)',
            '&:hover': {
              color: 'rgb(138, 43, 226)',
              fontWeight: 900,
              boxShadow: 'none',
            },
            transition: 'right 0.8s ease',
            zIndex: 1300,
            fontSize: '1.0rem',
          }}
        >
          {isOpen ? (
            <>
              <HorizontalRuleRoundedIcon sx={{ transform: 'rotate(90deg)', opacity: isHovered ? 0 : 1, transition: 'opacity 0.3s' }} />
              <ChevronRight sx={{ position: 'absolute', opacity: isHovered ? 1 : 0, transition: 'opacity 0.3s' }} />
            </>
          ) : (
            <>
              <HorizontalRuleRoundedIcon sx={{ transform: 'rotate(90deg)', opacity: isHovered ? 0 : 1, transition: 'opacity 0.3s' }} />
              <ChevronLeft sx={{ position: 'absolute', opacity: isHovered ? 1 : 0, transition: 'opacity 0.3s' }} />
            </>
          )}
        </IconButton>
      </Tooltip>

      <Drawer
        sx={{
          width: isOpen ? '15%' : '0%',
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: isOpen ? '15%' : '0%',
            backgroundColor: theme.palette.background.paper,
            border: 'none',
            display: 'flex',
            marginTop: '15px',
            borderTopLeftRadius: '15px',
            flexDirection: 'column',
            padding: '10px',
            transition: 'width 0.8s ease, transform 0.8s ease !important',
          },
          transition: 'width 0.8s ease !important',
          ...sx,
        }}
        variant="persistent"
        anchor="right"
        open={isOpen}
        transitionDuration={800}
      >
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '10px',
          height: '100%', 
          paddingBottom: '15px',
          position: 'relative'
        }}>
          
            <Box 
              sx={{ 
                flex: '0 0 auto',
                height: '77%',
                overflow: 'auto',
                marginBottom: '10px'
              }}
            > 
              <PdfViewer />
            </Box>
          
          <Box sx={{ 
            height: '23%',
            overflow: 'auto'
          }}>
            <KnowledgeBase />
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default RightSection;
